import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { BForm, BSubmit, BTextField } from 'mui-bueno';
import { useCardStyles, useFormStyles } from '../../App';
import Box from '@material-ui/core/Box';
import theme from '../../theme';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as Yup from 'yup';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles({
	root: {
		margin: '0 auto',
		padding: '30px',
		backgroundColor: theme.palette.secondary.dark,
		borderRadius: '10px',
	},
	inputField: {
		width: '100%',
        margin: '10px 0 10px'
	},
	deleteButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		width: '250px',
		backgroundColor: theme.palette.warning.main,
	},
	resetButton: {
		textAlign: 'center',
		margin: '15px auto 20px',
		backgroundColor: theme.palette.secondary.dark,
	},
	confirmationText: {
		color: theme.palette.common.white,
		marginLeft: '0px',
	},
    dialogContent: {
        marginTop: '0px'
    },
	bold: {
		color: theme.palette.grey[400],
		textShadow: '1px 1px 1px black',
	},
});

export type UpdateItemConfirmationProps = {
    id: string;
	name: string;
	confirmationText: string;
	onSubmit: any;
};

const UpdateItemConfirmation = (props: UpdateItemConfirmationProps) => {
	// const globalClasses = useOtherStyles();
	const formClasses = useFormStyles();
	const history = useHistory();
	const dispatcher = useDispatch();
	const classes = useStyles();
	const cardStyles = useCardStyles();

	const Schema = Yup.object({
		confirmation: Yup.string()
			.oneOf([props.confirmationText], 'Names must match')
			.required(`You must confirm your decision`),
	});

	const initialValues: any = {
		confirmation: '',
	};

    const handleDeleteItem = (data: any) => {
		props.onSubmit(props.id).then((res: any) => {
			history.push(`/${props.name}s`);
		})
		.catch((error: any) => {
			console.log("Error: ", error);
		})
	}

	return (
		<Box className={formClasses.formWrapper}>
			{/* <Card className={cardStyles.card}> */}
			<DialogTitle className={formClasses.formTitle}>
				Are you sure you want to delete this {props.name}?
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
                <Typography
                    className={classes.confirmationText}
                    variant='caption'
                >
                    Please type{' '}
                    <b className={classes.bold}>{props.confirmationText}</b> to
                    confirm
                </Typography>
				<Formik
					initialValues={initialValues}
					onSubmit={handleDeleteItem}
					validateOnChange={true}
					validateOnBlur={true}
					validationSchema={Schema}
					validateOnMount={true}
				>
					{(formik) => (
						<BForm>
							<BTextField
								required
								name='confirmation'
								label='Confirm'
								full
								className={classes.inputField}
							/>

							<BSubmit
								buttonProps={{ disabled: !formik.isValid }}
								className={classes.deleteButton}
								name='submit'
							>
								Delete {props.name}
							</BSubmit>
						</BForm>
					)}
				</Formik>
			</DialogContent>

			{/* </Card> */}
		</Box>
	);
};

export default UpdateItemConfirmation;
